import Vue, { CreateElement } from 'vue';
import { VueConstructor } from 'vue/types/vue';
import VueRouter, { RouteConfig, Route } from 'vue-router';
import VueCompositionApi from '@vue/composition-api';
import { hybrid } from '@kd/hybrid';
import VueLazyload from 'vue-lazyload';
import HTTP from '../api/http';
import logger from '@w/utils/logger';
import dirLogger from '@d/logger';
import { route } from '@w/utils/router';
import { getAppInfo } from '@w/utils/system';
import { Toast } from 'nut';
import NotFound from './error.vue';
import '@a/base.less';
// @ts-ignore no-types
import { zs } from '@zyb-data/stats-h5';
interface PageOptions {
  routes: RouteConfig[];
  isStatic?: number;
  useRouter?: boolean;
  entry?: string;
  data?: { [key: string]: unknown };
  keepAlive?: string;
  beforeInitial?(V: VueConstructor): void;
}

let nt: string;

const isOnline = process.env.KD_ENV === 'online';

class Page {
  private instanceOptions: { [index: string]: any } = {}; // eslint-disable-line

  constructor(private options: PageOptions) {
    this.init();
  }

  async init(): Promise<void> {
    await this.commonInit();
    this.monitorInit();
    this.directiveInit();
    this.optionsInit();
    this.options.beforeInitial && this.options.beforeInitial(Vue);
    new Vue(this.instanceOptions).$mount('#app'); // eslint-disable-line
  }

  monitorInit(): void {
    // 全埋点
    zs.config({
      plat: 'kdApp',
      zpID: 'PKD-KD-C',
      env: process.env.NODE_ENV,
      debug: !isOnline,
      logUrl: isOnline
        ? 'https://log.kuaiduizuoye.com/log/kuaidui_autotrack/h5'
        : 'https://log.kuaiduizuoye.com/log/h5_test',
    });
    zs.init();
  }

  async commonInit(): Promise<void> {
    const appInfo = await getAppInfo(hybrid);
    nt = appInfo.nt;
    Vue.use(VueCompositionApi);
    Vue.use(VueRouter);
    Vue.use(HTTP);
    Vue.use(VueLazyload);
    Vue.use(Toast);
    Vue.route = Vue.prototype.route = route;
    Vue.$cmn = Vue.prototype.$cmn = appInfo;
    Vue.logger = Vue.prototype.logger = logger;
    Vue.hybrid = Vue.prototype.hybrid = hybrid;
    /* eslint-disable @typescript-eslint/no-explicit-any */
    Vue.setData = (key: string, value: any) => {
      // eslint-disable-line
      this.instanceOptions[key] = value;
    };
    // 兼容Android & iOS无故调用全局方法
    // if (appInfo.os === 'ios') {
    //   /* eslint-disable @typescript-eslint/no-empty-function */
    //   window.fePageDestroy = window.fePageDestroy || (() => {});
    //   window.fePagePause = window.fePagePause || (() => {});
    // }
  }

  getRouterConfig(): VueRouter {
    const isStatic = this.options.isStatic || 1;
    const routes = this.options.routes;
    const router = new VueRouter({
      routes: [
        ...routes,
        {
          name: '404',
          path: '/404',
          component: NotFound,
          meta: { title: '哎呀，找不到啦~' },
        },
      ],
    });
    // 路由守卫
    router.beforeEach((to, from, next) => {
      const title = to.meta.title || '';
      document.title = typeof title === 'function' ? title(to) : title;
      document.documentElement.setAttribute(
        'page',
        to.name ||
          window.location.href.replace(/.+\/(\w+)\.html#(\/\w+)\?*.*/, '$1$2'),
      );
      if (nt === 'off' && to.name !== '404' && isStatic === 2) {
        next({ path: '/404', replace: true });
      } else {
        // 兼容端上链接拼错
        if (
          to.path === '/wholeBook&KdzyHideTitle=1' &&
          location.href.includes('uploadListGather')
        ) {
          Vue.hybrid('commonHideTitleBar', { is_hide: 1 });
          next({ path: '/wholeBook', replace: true });
        }
        next();
      }
    });
    return router;
  }

  directiveInit(): void {
    Vue.directive('log', dirLogger.loggerPV);
    Vue.directive('log-click', dirLogger.loggerClick);
  }

  optionsInit(): void {
    // const useRouter = this.options.routes.length > 1 || this.options.useRouter;
    const _ = { data: this.options.data || {} };

    const router = this.getRouterConfig();
    Vue.$rm = Vue.prototype.$rm = router;
    this.instanceOptions = {
      ..._,
      router: router,
      render: function (h: CreateElement) {
        if ((this.$route as Route).meta.keepAlive) {
          return h('div', { attrs: { id: 'app' } }, [
            h('keep-alive', [h('router-view')]),
          ]);
        } else {
          return h('div', { attrs: { id: 'app' } }, [h('router-view')]);
        }
      },
    };
    // if (useRouter) {
    //   const router = this.getRouterConfig();
    //   Vue.$rm = Vue.prototype.$rm = router;
    //   this.instanceOptions = {
    //     ..._,
    //     router: router,
    //     render: function (h: CreateElement) {
    //       if ((this.$route as Route).meta.keepAlive) {
    //         return h('div', { attrs: { id: 'app' } }, [h('keep-alive', [h('router-view')])]);
    //       } else {
    //         return h('div', { attrs: { id: 'app' } }, [h('router-view')]);
    //       }
    //     }
    //   };
    // } else {
    //   // 路由只有一个不使用 vue-router
    //   const cur = this.options.routes[0];
    //   this.instanceOptions = {
    //     ..._,
    //     render: (h: CreateElement) => h('div', { attrs: { id: 'app' } }, [h((cur as any).component)]) // eslint-disable-line
    //   };
    // }
  }
}

export default Page;
